import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
// import { createLogger } from "redux-logger";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import reducers from './../reducers';

const persistConfig = {
    key: 'root',
    storage: storage,
    blacklist: ['user','setting','massages'],
    stateReconciler: autoMergeLevel2
};
const pReducer = persistReducer(persistConfig, reducers);

// const logger = createLogger();
const initialState = {};

/*
export default function configureStore() {
    let store;

    if (module.hot) {
        store = createStore(
            reducers,
            initialState,
            compose(
                applyMiddleware(
                    thunkMiddleware,
                    logger
                ),
                window.devToolsExtension ? window.devToolsExtension() : f => f
            )
        );
    } else {
        store = createStore(
            reducers,
            initialState,
            compose(applyMiddleware(thunkMiddleware), f => f)
        );
    }

    return store;
}
*/
let storeN;
if (module.hot) {
    storeN = createStore(
        pReducer,
        initialState,
        compose(
            applyMiddleware(thunkMiddleware
                // , logger
            ),
            window.devToolsExtension ? window.devToolsExtension() : f => f
        )
    );
} else {
    storeN = createStore(
        pReducer,
        initialState,
        compose(applyMiddleware(thunkMiddleware), f => f)
    );
}
export const store = storeN;
export const persistor = persistStore(store);
